export default {"src":"/_next/static/media/MuteOn.b3e85c8f.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};